export default __webpack_public_path__ + "static/media/Ballroll_00070.ca4cb9f6.png";